import { openBlock as t, createElementBlock as l, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(v, e) {
  return t(), l("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M4.756 21q-.724 0-1.24-.516A1.7 1.7 0 0 1 3 19.246V6.968q0-.723.515-1.239a1.7 1.7 0 0 1 1.241-.515h7.837l-1.756 1.754h-6.08v12.278h12.292v-6.095l1.756-1.754v7.849q0 .723-.515 1.238a1.7 1.7 0 0 1-1.241.516zm9.812-15.281 1.252 1.227-5.796 5.789v1.25h1.23l5.817-5.81 1.251 1.227L12 15.738H8.268v-3.727zm3.754 3.683-3.754-3.683 2.195-2.193Q17.29 3 18.026 3t1.24.526l1.23 1.25Q21 5.28 21 6.004q0 .723-.505 1.227z"
    }, null, -1)
  ])]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
